import { QueryParams } from 'common/urls/QueryParams';
import React from 'react';
import { DishFirstSegmentFilter, Protein } from 'src/gqlReactTypings.generated.d';
import {
  QueryParamsUpdates,
  QueryParamsUpdateType,
  UseDishFirstExploreUrl,
} from 'src/pages/consumer/explore/useExploreUrl';
import { PROTEIN_TO_DISPLAY_INFO } from '../../MoreFilters/consts';
import { Filters } from './Filters';

const proteinCategories = Object.entries(PROTEIN_TO_DISPLAY_INFO).map(([tag, { Icon, title }]) => ({
  tag: tag as Protein,
  icon: <Icon />,
  label: title,
}));

export function getProteinCategoriesToDisplay() {
  return [
    ...proteinCategories.map((c) => ({
      ...c,
      queryParam: QueryParams.PROTEIN_FILTER,
    })),
  ];
}

interface BrowseByTagsFilterProps {
  filters: UseDishFirstExploreUrl;
  updateQueryParams: (updates: QueryParamsUpdates<DishFirstSegmentFilter>, updateType?: QueryParamsUpdateType) => void;
}

export const ProteinFilters: React.FC<BrowseByTagsFilterProps> = ({ filters, updateQueryParams }) => {
  const categories = getProteinCategoriesToDisplay();
  return (
    <Filters
      filterTitle='Browse by protein'
      filters={filters}
      updateQueryParams={updateQueryParams}
      categories={categories}
    />
  );
};
